export const PAYPAL_PLAN_TO_NAME = {
    // Live
    'P-8W460836KX511983SL3SFLRY': 'backer_monthly',
    'P-4BE32205WC8099423L3SFM5Y': 'backer_yearly',
    'P-7R9961430T230120CL3SFMDA': 'patron_monthly',
    'P-1H169679XR034493GL3SFMMI': 'patron_yearly',
    // Test sandbox
    'P-2LS877027G7055319L3OWXGI': 'backer_monthly',
    'P-0C150984PD4532505L3OWWVQ': 'backer_yearly',
    'P-21K9973416833342TL3OWXOA': 'patron_monthly',
    'P-4SW19357A6322715YL3OWXVA': 'patron_yearly',
};
